import React, { ReactNode } from "react";
import { Card, Divider } from "@mui/material";
import ByzMuiTypography from "../mui/inputs/ByzMuiTypography";

interface ByzCardProps {
  title?: ReactNode;
  children: ReactNode;
  shadow?: boolean;
  sx?: object;
}

const ByzCard: React.FC<ByzCardProps> = ({
  title,
  children,
  shadow = false,
  sx,
}) => {
  return (
    <Card
      sx={{
        mb: 3,
        p: 2,
        boxShadow: shadow ? "0px 4px 4px 0px #00000040" : "none",
        borderRadius: "4px",
        gap: "10px",
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: "#ccc",
        padding: "15px" ,
        ...sx,
      }}
    >
      {title && (
        <>
          <ByzMuiTypography isTitle>{title}</ByzMuiTypography>
          <Divider
            sx={{
              borderColor: "#E0E0E0",
              borderBottomWidth: "2px",
              my: 2,
            }}
          />
        </>
      )}
      {children}
    </Card>
  );
};

export default ByzCard;
